import { GlobalWorkerOptions } from "pdfjs-dist";

// PDF.js 4 calls Promise.withResolvers, which is missing on iOS Safari below
// 17.4, Chrome below 119 and Firefox below 121. Without it the viewer throws
// before it renders a single page.
const PROMISE_WITH_RESOLVERS_POLYFILL =
  'if(typeof Promise.withResolvers!=="function"){Promise.withResolvers=function(){' +
  "var resolve,reject;var promise=new Promise(function(res,rej){resolve=res;reject=rej;});" +
  "return{promise:promise,resolve:resolve,reject:reject};};}\n";

export function installPromiseWithResolvers() {
  if (typeof Promise.withResolvers !== "function") {
    Promise.withResolvers = function withResolvers() {
      let resolve;
      let reject;
      const promise = new Promise((res, rej) => {
        resolve = res;
        reject = rej;
      });

      return { promise, resolve, reject };
    };
  }
}

installPromiseWithResolvers();

const workerAssetUrl = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url,
).toString();

let workerSetup = null;

/**
 * PDF.js starts its worker with `new Worker(src, { type: "module" })`, and a
 * module worker is refused outright unless the server returns a JavaScript
 * MIME type. Apache and most shared hosts do not map the .mjs extension, so
 * the worker is served as application/octet-stream and the viewer fails on
 * every browser and device.
 *
 * Fetching the worker and handing PDF.js a blob URL makes the MIME type ours
 * rather than the server's, and lets us prepend the polyfill the worker scope
 * needs. If the fetch fails we fall back to the plain asset URL, which still
 * works on any host that is configured correctly.
 */
export function ensurePdfWorker() {
  if (workerSetup) {
    return workerSetup;
  }

  workerSetup = fetch(workerAssetUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Worker request failed with ${response.status}`);
      }

      return response.text();
    })
    .then((source) => {
      const blob = new Blob([PROMISE_WITH_RESOLVERS_POLYFILL, source], {
        type: "text/javascript",
      });

      GlobalWorkerOptions.workerSrc = URL.createObjectURL(blob);
    })
    .catch(() => {
      GlobalWorkerOptions.workerSrc = workerAssetUrl;
    });

  return workerSetup;
}
